import { render, staticRenderFns } from "./crudPerceptions.vue?vue&type=template&id=da414228&"
import script from "./crudPerceptions.vue?vue&type=script&lang=js&"
export * from "./crudPerceptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports